<template>
  <div
    id="Menu1"
    v-if="isVisible"
    class="overflow-auto bg-white instrumentsAndAccessoiresMenu"
  >
    <div class="row">
      <div class="col-md-12 col-lg-6 ">
        <p class="fontp text-left">
          {{ $t("single_use_electrosurgical_pencils") }}
        </p>
        <ul class="bulletArrowSmall">
          <li
            class="instrumentsAndAccessoiresMenuList"
            v-for="element in positiveAspects"
            :key="element"
          >
            <span class="liFontSmallBold">{{ $t(element) }}</span>
          </li>
        </ul>
        <img class="insturmentsImg" src="@/assets/images/instrumente.jpg" />
      </div>

      <div class="col-md-12 col-lg-6  text-left">
        <div v-for="product in productList" :key="product.productNr">
          <hr class="instrumentsAndAccessoiresMenuSeperator" />
          <div class="row">
            <div class="col-3 text-left liFontSmallBold">
              {{ product.productNr }}
            </div>
            <div class="col-9 text-left liFontSmallLight">
              {{ product.productInfo }}
            </div>
          </div>
        </div>

        <hr class="instrumentsAndAccessoiresMenuSeperator" />
        <LabeledButton
          :label="$t('Go_to_accessories')"
          :onClick="
            () => {
              toggle('Menu2');
            }
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { languageAdapter } from "@/services/languageAdapter";
import LabeledButton from "@/components/LabeledButton";
export default {
  name: "InstrumentsMenu1",
  props: {
    toggle: Function,
    isVisible: Boolean
  },
  components: { LabeledButton },
  data() {
    return {
      positiveAspects: [
        "surgical_smoke_extraction_at_source",
        "clean_working_env_view",
        "ergonomic_design"
      ]
    };
  },
  computed: {
    productList() {
      return [
        {
          productNr: "20321-028",
          productInfo: this.$t("electrosurgical_pencil_for_IES")
        },
        {
          productNr: "20321-040",
          productInfo: this.$t("smoke_evacuation_pencil_spatula_electrode")
        },
        {
          productNr: "20321-041",
          productInfo: this.$t(
            "smoke_evacuation_pencil_coated_spatula_electrode"
          )
        },
        {
          productNr: "20321-042",
          productInfo: this.$t("smoke_evacuation_pencil_spatula_electrode_5m")
        },
        {
          productNr: "20321-043",
          productInfo: this.$t(
            "smoke_evacuation_pencil_coated_spatula_electrode_5m"
          )
        },
        {
          productNr: "20321-044",
          productInfo:
            this.$t("clip_on_handle_smoke_evacuation") +
            "\n" +
            this.$t("usage_with_erbe_slim_line_electrosurgical_pencils")
        },
        {
          productNr: "20321-045",
          productInfo:
            this.$t("extemsion_tip_clip_on_handle") +
            "\n" +
            this.$t("used_in_combination_20321_044")
        }
      ];
    }
  }
};
</script>
<style scoped>
.fontp {
  margin-bottom: 0.5rem;
}
.insturmentsImg {
  margin-top: 20px;
}
.instrumentsAndAccessoiresMenuList {
  color: black;
  padding-top: 10px;
}
.instrumentsAndAccessoiresMenuList:first-of-type {
  color: black;
  padding-top: 0;
}
.labeledbutton {
  float: right;
}
</style>
